import { createTheme } from "@mui/material/styles";

export const premiumTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#D4AF37",
      light: "#F3E5AB",
      dark: "#B8860B",
      contrastText: "#000000",
    },
    secondary: {
      main: "#1A1A1A",
      light: "#333333",
      dark: "#000000",
    },
    background: {
      default: "transparent",
      paper: "#FFFFFF",
    },
    text: {
      primary: "#111111",
      secondary: "#555555",
      disabled: "#AAAAAA",
    },
    error: { main: "#E53E3E" },
    warning: { main: "#F59E0B" },
    info: { main: "#3182CE" },
    success: { main: "#38A169" },
    divider: "#E2E8F0",
    action: {
      hover: "rgba(0,0,0,0.04)",
      selected: "rgba(0,0,0,0.08)",
    },
  },
  typography: {
    fontFamily: '"Inter", "Segoe UI", "Roboto", sans-serif',
    h1: { fontWeight: 700, letterSpacing: "-0.02em" },
    h2: { fontWeight: 700, letterSpacing: "-0.01em" },
    h3: { fontWeight: 600 },
    h4: { fontWeight: 600 },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
    button: { textTransform: "none", fontWeight: 500 },
  },
  shape: {
    borderRadius: 16,
  },
  shadows: [
    "none",
    "0px 2px 4px rgba(0,0,0,0.05)",
    "0px 4px 12px rgba(0,0,0,0.08)",
    "0px 8px 20px rgba(0,0,0,0.1)",
    "0px 12px 28px rgba(0,0,0,0.12)",
    ...Array(20).fill("0px 8px 20px rgba(0,0,0,0.1)"),
  ],
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          position: "relative",
          minHeight: "100vh",
          // Teal gradient (strong at top, fading to transparent at bottom)
          // background: `linear-gradient(
          //   360deg,
          //   rgba(12, 138, 155, 0.49) 0%,
          //   rgba(12, 138, 155, 0.09) 30%,
          //   rgba(255, 255, 255, 255) 60%,
          //   rgb(255, 255, 255) 100%
          // )`,
          "&::before": {
            content: '""',
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            // backgroundImage: `url("/images/bgcImage.png")`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            // Lower the overall image opacity (make it subtler)
            opacity: 0.2,
            // Mask creates fade-in: top invisible → bottom fully visible (but opacity already 0.3)
            maskImage: `linear-gradient(to bottom, rgba(0,0,0,0), rgba(0,0,0,1) 40%, rgba(0,0,0,1) 100%)`,
            WebkitMaskImage: `linear-gradient(to bottom, rgba(0,0,0,0), rgba(0,0,0,1) 40%, rgba(0,0,0,1) 100%)`,
            zIndex: -2,
            pointerEvents: "none",
          },
        },
      },
    },
    // All other component overrides remain exactly as you had them
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          padding: "8px 20px",
          transition: "all 0.2s ease",
        },
        containedPrimary: {
          background: "linear-gradient(135deg, #D4AF37 0%, #B8860B 100%)",
          boxShadow: "0 4px 12px rgba(212, 175, 55, 0.2)",
          "&:hover": {
            transform: "translateY(-2px)",
            boxShadow: "0 8px 20px rgba(212, 175, 55, 0.3)",
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 20,
          backgroundColor: "#FFFFFF",
          boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
          transition: "all 0.25s ease",
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: "none",
          backgroundColor: "#FFFFFF",
        },
        rounded: { borderRadius: 20 },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: { borderBottom: "1px solid #E2E8F0", padding: "14px 16px" },
        head: { fontWeight: 600, backgroundColor: "#FAFAFA", color: "#111" },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: { borderRadius: 8, fontWeight: 500 },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: { borderTopLeftRadius: 24, borderBottomLeftRadius: 24 },
      },
    },
  },
});
